import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    CardHeader,
    Avatar,
    IconButton,
    Tooltip,
    CardContent,
    Typography,
    useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoadingSpinner from './LoadingSpinner';
import UnavailableFeatureIcon from '../assets/UnavailableFeatureIcon';

const TileDetailUnavailable = ({ show, onClose, icon, title }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loading);
    const [isDocumentSelected, setIsDocumentSelected] = useState(false);

    const handleClose = () => {
        setIsDocumentSelected(false);
        onClose();
    };

    return loading ? (
        <LoadingSpinner />
    ) : (
        <Box
            sx={{
                width: '600px',
                minWidth: '200px',
                minHeight: '100px',
                margin: 2,
                opacity: 0,
                animation: 'fadeIn 0.2s ease-in forwards',
                transition: 'opacity 0.2s ease',
                background: theme.palette.mode === 'dark'
                    ? 'linear-gradient(180deg, #1e1e1e, #2c2c2c)'
                    : 'linear-gradient(180deg, #ffffff, #e4f2fb, #f2f2f2)',
                boxShadow: theme.shadows[3],
                borderRadius: 1,
                '@keyframes fadeIn': {
                    from: { opacity: 0 },
                    to: { opacity: 1 },
                },
            }}
        >
            <CardHeader
                action={
                    <Tooltip title="Cancel">
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                }
                title={
                    <Typography variant="h6" sx={{
                        fontSize: '16px',
                        textTransform: 'none',

                        color: theme =>
                            theme.palette.mode === 'dark'
                                ? theme.palette.grey[600]
                                : theme.palette.grey[800],

                    }}>
                        {title || 'Missing title'}
                    </Typography>
                }
                avatar={<Avatar>{icon || null}</Avatar>}
            />
            <CardContent
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: 1,
                        width: '100%',
                        border: `1px solid ${theme.palette.divider}`,
                        padding: 2,
                    }}
                >
                    <UnavailableFeatureIcon />
                </Box>
            </CardContent>
        </Box>
    );
};

export default TileDetailUnavailable;
